import { reducer as reduxAsyncConnect } from 'redux-connect';
import app from './app';
import cityBikes from './cityBikes';
import search from './search';
import order from './order';
import i18n from './i18n';
import companies from './companies';
import staticPage from './staticPage';
import staticPages from './staticPages';
import profile from './profile';
import sitemap from './sitemap';

export default {
  reduxAsyncConnect,
  app,
  cityBikes,
  search,
  order,
  i18n,
  companies,
  staticPage,
  staticPages,
  sitemap,

  profile
};



// WEBPACK FOOTER //
// ./src/reducers/index.js